<template>
  <div class="sidebar-banners">
    <PartsChromeLink
      v-for="banner in SIDEBAR_BANNERS"
      :key="banner.src"
      :to="banner.to"
      :external="banner.external"
      class="banner-link"
    >
      <img :src="banner.src" :alt="banner.alt" />
    </PartsChromeLink>
  </div>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `sidebar-banners`（サイドバー下部のバナー）。
 *
 * **通常のサイドバーとマイページのサイドバーで中身が同じ**なので部品にしてある。
 * 支給のマイページ7本（`design-src/20260810/my-page/`）は
 * `sidebar-btns` と `sidebar-nav` を持たず、`my-page-sidebar-nav` ＋ このバナーだけ。
 *
 * 飛び先は `consts/ChromeConst.ts` の `SIDEBAR_BANNERS`。外部URLが混ざるので
 * `PartsChromeLink` を通す。**支給は4枚だがCSR活動バナーは出していない**（#1351・§8-29-①）。
 */
import { SIDEBAR_BANNERS } from '@/consts/ChromeConst';
</script>
